












import Vue from 'vue';

export interface Tab {
  text: string;
  value: string;
}

export default Vue.extend({
  name: 'Tabs',
  props: {
    tabs: Array as () => Tab[],
    value: String,
  },
  methods: {
    selectTab(tab: Tab) {
      this.$emit('input', tab.value);
    },
  },
  watch: {
    tabs: {
      immediate: true,
      handler(newTabs: Tab[]) {
        if (!newTabs.map((t) => t.value).includes(this.value)) {
          this.selectTab(this.tabs[0]);
        }
      },
    },
  },
});
